export const CREATE_LINK = 'CREATE_LINK';
export const GET_LINKS = 'GET_LINKS';
export const GET_LINKS_BYDATE = 'GET_LINKS_BYDATE';
export const GET_LINK = 'GET_LINK';
export const UPDATE_LINK = 'UPDATE_LINK';
export const DELETE_LINK = 'DELETE_LINK';
export const CREATE_CLICK = 'CREATE_CLICK';
export const GET_TEKIL = 'GET_TEKIL';
